import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { ensureMsalCacheVersion } from "./app/shared/msal-cache-guard";
import environment from "./environments/environment";

// Purge stale MSAL cache from an older major version before MSAL initializes.
ensureMsalCacheVersion();

if (environment.production) {
  enableProdMode();

  if (window) {
    window.console.log = () => {};
  }
}

platformBrowserDynamic().bootstrapModule(AppModule);
// .catch((err) => {});
